/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */
( function() {
	var isWebkit = navigator.userAgent.toLowerCase().indexOf( 'webkit' ) > -1,
	    isOpera  = navigator.userAgent.toLowerCase().indexOf( 'opera' )  > -1,
	    isIe     = navigator.userAgent.toLowerCase().indexOf( 'msie' )   > -1;

	if ( ( isWebkit || isOpera || isIe ) && document.getElementById && window.addEventListener ) {
		window.addEventListener( 'hashchange', function() {
			var id = location.hash.substring( 1 ),
				element;

			if ( ! ( /^[A-z0-9_-]+$/.test( id ) ) ) {
				return;
			}

			element = document.getElementById( id );

			if ( element ) {
				if ( ! ( /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) ) {
					element.tabIndex = -1;
				}

				element.focus();
			}
		}, false );
	}
})();

( function() {
	var headerHeight = document.querySelector('.site-header').offsetHeight;
   
	 // Add click event listeners to items inside #sm-tabs
	 document.querySelectorAll('#sm-tabs .item').forEach(function (item) {
	   item.addEventListener('click', function () {
		 // Scroll the entire page to the top plus header height
		 window.scrollTo({
		   top: document.getElementById('sm-tabs').getBoundingClientRect().top + window.scrollY - 70,
		   behavior: 'smooth'
		 });
	   });
	 });
})();
   
